import { render } from "./assetList.vue?vue&type=template&id=c1d6fab4&scoped=true"
import script from "./assetList.vue?vue&type=script&lang=js"
export * from "./assetList.vue?vue&type=script&lang=js"

import "./assetList.vue?vue&type=style&index=0&id=c1d6fab4&scoped=true&lang=scss"

import exportComponent from "D:\\JYC\\产品源码\\前端\\工作流引擎\\stgd.oa.mobile.h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1d6fab4"]])

export default __exports__